
const Today = (props: any) : JSX.Element => {
  return (
    <div>Today</div>
  )
} 

export default Today